import axios from "axios";

export interface ReStudyRecord {
  id: string;
  studentId: string;
  student: {
    id: string;
    firstName: string;
    lastName: string;
    admissionNumber: string;
    scholarNumber: string;
  };
  previousSessionId: string;
  previousSession: { id: string; name: string };
  newSessionId: string;
  newSession: { id: string; name: string };
  previousClassId: string;
  previousClass: { id: string; name: string };
  classId: string;
  class: { id: string; name: string };
  sectionId: string;
  section: { id: string; name: string };
  reason?: string;
  remarks?: string;
  createdAt: string;
}

export interface CreateReStudyPayload {
  studentId: string;
  previousSessionId: string;
  previousClassId: string;
  newSessionId: string;
  classId: string;
  sectionId: string;
  reason?: string;
  remarks?: string;
}

const reStudyApi = {
  findAll: async (filters: {
    sessionId?: string;
    classId?: string;
    sectionId?: string;
    search?: string;
  }) => {
    const response = await axios.get<ReStudyRecord[]>(
      "/scholar-register/re-study",
      {
        params: filters,
      },
    );
    return response.data;
  },

  create: async (payload: CreateReStudyPayload) => {
    const response = await axios.post(
      "/scholar-register/re-study",
      payload,
    );
    return response.data;
  },

  remove: async (id: string) => {
    const response = await axios.delete(
      `/scholar-register/re-study/${id}`,
    );
    return response.data;
  },

  getStudentHistory: async (studentId: string) => {
    const response = await axios.get<ReStudyRecord[]>(
      `/scholar-register/re-study/student/${studentId}`,
    );
    return response.data;
  },
};

export default reStudyApi;
